import React from 'react';

type Props = {
  className?: string;
  dimension?: number;
};

const Icon: React.FC<Props> = ({ className, dimension = 24 }: Props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={dimension} height={dimension} viewBox='0 0 24 24' fill="none" className={className}>
    <path
      d="M17.8996 3.20078C17.8996 3.50078 17.7996 3.80078 17.4996 4.10078L9.59961 12.0008L17.4996 19.9008C17.9996 20.4008 17.9996 21.2008 17.4996 21.7008C16.9996 22.2008 16.1996 22.2008 15.6996 21.7008L6.09961 12.0008L15.6996 2.30078C16.1996 1.80078 16.9996 1.80078 17.4996 2.30078C17.9996 2.80078 17.8996 2.90078 17.8996 3.20078Z"
      fill="currentColor"
    />
  </svg>
);

export default Icon;
